import Options from '../../Options.esm.js';

var repeatMatcher = (match => {
  let warning = Options.translations.warnings.extendedRepeat;

  if (match.baseToken.length === 1) {
    warning = Options.translations.warnings.simpleRepeat;
  }

  return {
    warning,
    suggestions: [Options.translations.suggestions.repeated]
  };
});

export { repeatMatcher as default };
//# sourceMappingURL=feedback.esm.js.map
